module.exports = __webpack_public_path__ + "static/vision-adec0ca82d8c0d807229187aaa9b1fa7.jpg";